import {
    fetchForCategory,
    fetchCategoryAttributeSuggestions
} from './attributes-actions';

import campaignCodeActions from './campaign-code-actions';
import { selectShortDescription } from 'tradera/apps/syi/state/selectors/syi';

import { webApiClient } from 'tradera/utils/http';
import { selectPreferredLanguage } from 'tradera/state/language/selectors';
import { setShippingRecommendations } from './shipping-actions';
import priceActions from './price-actions';
import draftActions from './draft-actions';
import { setCategoryRestriction } from '../reducers/syi';
import { fetchConditionAndItemTypeFromCategory } from 'tradera/apps/syi/state/actions/predictions-actions';
import { selectIsCompany } from 'tradera/state/member/selectors';
import { selectMagicalSyiSettngEnabled } from 'tradera/apps/syi/state/selectors/draft-selectors';
import { selectIsFeatureEnabled } from 'tradera/state/environment/selectors';

export const updateCategoryRestrictions =
    (categoryId) => async (dispatch, getState) => {
        if (!categoryId) {
            return;
        }

        const { languageCodeIso2 } = selectPreferredLanguage(getState());
        const { data } = await webApiClient.get(
            `/selling/category-restriction/${categoryId}?locale=${languageCodeIso2}`
        );
        dispatch(setCategoryRestriction(data));
        dispatch(draftActions.updateItemConditionRestrictionForCategory());
    };

const reset = () => (dispatch) => {
    dispatch({
        type: 'RESET_CATEGORY'
    });
};

const setDraftCategory = (categoryId, categoryPath) => (dispatch, getState) => {
    const shortDescription = selectShortDescription(getState());
    const isCompany = selectIsCompany(getState());
    const isMagicalSyiFeatureEnabled =
        selectIsFeatureEnabled('magical-syi')(getState());
    const isMagicalSyiSettingEnabled =
        selectMagicalSyiSettngEnabled(getState());
    const isAutoFillConditionAndListingTypeEnabled = selectIsFeatureEnabled(
        'auto-fill-condition-and-listing-type'
    )(getState());
    dispatch({
        type: 'SET_DRAFT_CATEGORY',
        categoryId: categoryId,
        categoryPath: categoryPath
    });
    dispatch(campaignCodeActions.validateCampaignCode());
    dispatch(updateCategoryRestrictions(categoryId));
    dispatch(fetchForCategory(categoryId));
    dispatch(fetchCategoryAttributeSuggestions(categoryId, shortDescription));
    dispatch(setShippingRecommendations(categoryId));
    if (
        isMagicalSyiSettingEnabled &&
        isMagicalSyiFeatureEnabled &&
        isAutoFillConditionAndListingTypeEnabled
    ) {
        dispatch(
            fetchConditionAndItemTypeFromCategory({ isCompany, categoryId })
        );
    }
    if (categoryPath?.length > 0) {
        dispatch(
            priceActions.rootCategoryHasBeenSelected(categoryPath[0].categoryId)
        );
    }
};

export default {
    setDraftCategory,
    reset
};
